import React, { useState } from 'react';
import ChatInterface from '../components/Chat/chatinterface';
import { useParams, useLocation } from 'react-router-dom';

export default function Chat() {
    const { id } = useParams(); // For project chat rooms
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const recipientId = searchParams.get('recipient');
    const [chatType] = useState(id ? 'project' : 'direct');
    
    // Get current user ID from localStorage
    const userId = localStorage.getItem('loginId');
    
    if (!userId) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="text-center">
                    <h2 className="text-xl font-semibold mb-2">Please Log In</h2>
                    <p>You need to be logged in to access the chat feature.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="h-screen">
            <ChatInterface 
                userId={userId}
                projectId={id}
                recipientId={recipientId}
                chatType={chatType}
            />
        </div>
    );
}